import Vue from "vue"
import VueI18n from "vue-i18n"

import tr_TR from "./tr_TR.json"
import en_US from "./en_US.json"
import ar_AR from "./ar_AR.json"
import ru_RU from "./ru_RU.json"
import az_AZ from "./az_AZ.json"
import de_DE from "./de_DE.json"
import es_ES from "./es_ES.json"
import fr_FR from "./fr_FR.json"
import it_IT from "./it_IT.json"
import bg_BG from "./bg_BG.json"
import iw_IL from "./iw_IL.json"
import du_DU from "./du_DU.json"
import el_EL from "./el_EL.json"
import al_AL from "./al_AL.json"
import ro_RO from "./ro_RO.json"
import sr_CS from "./sr_CS.json"
import zh_CN from "./zh_CN.json"

Vue.use(VueI18n)

const locales = {
  en_US,
  tr_TR,
  ar_AR,
  ru_RU,
  az_AZ,
  de_DE,
  es_ES,
  fr_FR,
  it_IT,
  bg_BG,
  iw_IL,
  du_DU,
  el_EL,
  al_AL,
  ro_RO,
  sr_CS,
  zh_CN
}

const i18n = new VueI18n({
  locale: "en_US",
  fallbackLocale: "en_US",
  messages: locales,
  silentTranslationWarn: true
})

i18n._locales = Object.keys(locales)
export default i18n
